/**
 * Created by TTND on 1/23/2018.
 */
import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import ImageComponent from '../../../general/Image';
import './style.scss';

export default class ImageDesignation extends React.Component{

    render(){
        let {item} = this.props;

        return(
        <div className="image-designation">
                {item.image && <ImageComponent image={{desc: item.position, alt: item.name, ...item.image}} options={{width:'100', aspectRatio: '1:1'}}/>}
                {item.picture && <ImageComponent image={item.picture} options={{width:'100', aspectRatio: '1:1'}}/>}
                {item.name && <div className="name">{item.name}</div>}
                {item.position && <div className="position">{item.position}</div>}
            </div>
        )
    }
}